import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.22 3.982a1 1 0 0 0-1.415-1.414L2.568 6.805A1 1 0 1 0 3.982 8.22zM23.78 2.568a1 1 0 0 1 1.415 0l4.237 4.237a1 1 0 0 1-1.414 1.415L23.78 3.982a1 1 0 0 1 0-1.414M17 9a1 1 0 1 0-2 0v7a1 1 0 0 0 1 1h7a1 1 0 1 0 0-2h-6z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4C9.372 4 4 9.372 4 16c0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12M6 16c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10S6 21.523 6 16"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconAlarm = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconAlarm);
export default Memo;
